export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-[#1A2B4A] to-[#2C4A7C] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-center">
          {/* Info Card */}
          <div className="w-full max-w-xl">
            <div className="bg-white rounded-3xl p-10 shadow-2xl">
              <h3 className="text-[#1A2B4A] font-bold text-2xl mb-8">Contattaci</h3>

              {/* Phone */}
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#FF6B35] flex-shrink-0">
                  <i className="ri-phone-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-sm mb-1">Telefono</p>
                  <a href="tel:+393806328251" className="text-[#1A2B4A] font-bold text-lg hover:text-[#00A3E0] transition-colors cursor-pointer whitespace-nowrap">
                    +39 380 632 8251
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#00A3E0] flex-shrink-0">
                  <i className="ri-mail-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-sm mb-1">Email</p>
                  <a href="mailto:robertoanton@gmail.com" className="text-[#1A2B4A] font-semibold hover:text-[#00A3E0] transition-colors cursor-pointer break-all">
                    robertoanton@gmail.com
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#00A3E0] flex-shrink-0">
                  <i className="ri-map-pin-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-500 text-sm mb-1">Indirizzo</p>
                  <p className="text-[#1A2B4A] font-semibold">
                    Via Faentina<br />
                    48123 Ravenna, Italia
                  </p>
                </div>
              </div>

              {/* Hours Badge */}
              <div className="mt-8 pt-8 border-t border-gray-200">
                <div className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-5 py-3 rounded-full font-bold text-sm">
                  <i className="ri-time-line text-lg"></i>
                  Disponibili 24/7
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
